<!--审批模板-->
<template>
	<div>
		<div class="template_div">
			<div class="order_sn_div">
				<span>申请单号：此处展示模板单号</span>
				<span>此处展示操作时间</span>
			</div>
			<div class="title_div">
				<span>{{tempName}}</span>
			</div>
			<el-form label-position="left" label-width="100px">
				<el-form-item label="申请账号：" style="margin-bottom: 5px;">
					<span>此处展示操作账号名称</span>
				</el-form-item>
				<el-divider class="lin" />
				<div class="row_" :class="select == index ? 'after':''" v-for="(item,index) in TemplateList"
					:key="index" @click="itemClick(index)">
					<span :class="item.required ? 'must':''">{{item.name+'：'}}</span>
					<span v-if="item.templateType != 3" class="input">{{item.placeholder}}</span>
					<span class="input" v-else>{{item.placeholder}}</span>
				</div>
				<el-card v-if="show" class="btn">
					<div class="tab_div" style="margin: 0;">
						<span>控件类型</span>
						<span @click="show = false">关闭</span>
					</div>
					<div class="tab_div">
						<el-button plain v-for="(item,index) in tabList" @click="addItem(index)">{{item}}</el-button>
					</div>
					<span>提示：选择控件类型，即可在模拟框中显示该控件， 点击框中的该控件，即可进行编辑</span>
				</el-card>
			</el-form>
		</div>
		<div class="title_div">
			<el-button plain @click="show = true">+ 添加内容控件</el-button>
		</div>
	</div>

</template>

<script>
	export default {
		props: {
			TemplateList: {
				type: Array
			},
			tempName:{
				type:String
			}
		},
		data() {
			return {
				show: false,
				value: [],
				dataTime: '',
				select: -1,
				tabList: ['文本', '日期时间', '单选框', '附件']
			}
		},
		methods: {
			itemClick(index) {
				this.select = index;
				this.$emit('itemClick', index)
			},
			addItem(index) {
				var key = this.TemplateList.findIndex(item=>item.templateType == index)
				let arr = JSON.stringify(this.TemplateList[key]);
				this.TemplateList.push(JSON.parse(arr));
			},
			updateStyle(index){
				this.select = index;
			},
			clean(){
				this.select = -1;
			}
		}
	}
</script>

<style scoped>
	.template_div {
		display: flex;
		flex-direction: column;
		position: relative;
		width: 400px;
		height: auto;
		border: 1px solid #DCDFE6;
		padding: 40px 20px;
		border-radius: 5px;
	}

	.order_sn_div {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		font-size: 14px;
		color: #606266;
	}

	.title_div {
		width: 100%;
		font-size: 24px;
		color: #000;
		display: flex;
		justify-content: center;
		padding: 20px 0 10px 0;
	}

	.row {
		display: flex;
		flex-direction: row;
		justify-content: space-around;
	}

	.row_ {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		margin: 20px 0;
		padding: 15px 0 5px 0;
	}

	.after {
		border: 1px dashed #00A292;
	}

	.lin {
		margin: 0 0 10px 0;
	}

	.must:after {
		position: absolute;
		content: '*';
		color: red;
		font-size: 18px;
	}

	.input {
		width: 78%;
		padding-bottom: 10px;
		border-bottom: 1px solid #DCDFE6;
	}

	.btn {
		display: flex;
		flex-direction: column;
		position: relative;
		margin-top: 80px;
	}

	.tab_div {
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		margin: 20px 0;
	}
</style>